import { Typography } from '@nutrien/ddc-components';
import { useCorrelateLogging } from '@nutrien/ddc-fe-logging-react-router-dom';
import { useEffect } from 'react';

import Navigation from './Navigation/Navigation';

const One = () => {
  const { info } = useCorrelateLogging();
  useEffect(() => info('One:mount'), [info]);

  return (
    <>
      <Typography variant="headline1">PWA One</Typography>
      <Navigation />
    </>
  );
};

export default One;
